import { render, staticRenderFns } from "./areaAppealTypeList.vue?vue&type=template&id=1f070ca6&scoped=true"
import script from "./areaAppealTypeList.vue?vue&type=script&lang=js"
export * from "./areaAppealTypeList.vue?vue&type=script&lang=js"
import style0 from "./areaAppealTypeList.vue?vue&type=style&index=0&id=1f070ca6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f070ca6",
  null
  
)

export default component.exports